import { render, staticRenderFns } from "./FormValidate.vue?vue&type=template&id=730d2038&scoped=true&"
import script from "./FormValidate.vue?vue&type=script&lang=js&"
export * from "./FormValidate.vue?vue&type=script&lang=js&"
import style0 from "./FormValidate.vue?vue&type=style&index=0&id=730d2038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d2038",
  null
  
)

export default component.exports